module.exports = __webpack_public_path__ + "img/carousel1.6e0412e7.jpg";